import { useService } from 'hooks/useService';
import Button from 'components/partials/Fields/Button';
import Phone from 'components/partials/Fields/Phone';
import { PUT } from 'services/RequestMethods';
import FormTools from 'components/partials/Fields/FormTools';
import { general_error_toastr } from 'components/partials/Notification';
import { is_form_valid } from 'helpers/parsley';
import Col from 'react-bootstrap/Col';
import { useLoginContext } from '../../_context/useLoginContext';

export const UpdatePhone = ({
    setPhone,
    phone,
}) => {
    const { setRequirePhone, requirePhone } = useLoginContext();
    const [_, fireVerifyPhone] = useService({ method: PUT, url: '/users/account/update-phone' });

    const handleOnChange = ({ target: { value, name } }) => setPhone(prev => ({ ...prev, [name]: value }));

    const handleSubmit = (e) => {
        fireVerifyPhone({ params: phone })
            .then(res => {
                if (res.message === 'OK') {
                    return setRequirePhone(false);
                }
            })
            .catch(e => {
                console.log(e);
                general_error_toastr();
            });
    };

    const checkParsleyFormValid = async e => {
        e.preventDefault();
        const isValid = is_form_valid('mfa-verify-phone');

        return isValid;
    };

    return (
        <>
            <Col className="text-center">
                <h2 className="section-title">Confirm your phone number</h2>
            </Col>
            <br/>
            <Col className="text-center">
                <p>
                    We are securing the login process with Multi-Factor Authentication. For this
                    reason, we would like for you to confirm your phone number below.
                </p>
            </Col>
            <br/>
            <form
                id="mfa-verify-phone"
                className="w-100"
                onSubmit={checkParsleyFormValid}
            >
                <FormTools
                    hasAsyncValidator
                    formID="mfa-verify-phone"
                    onSubmit={handleSubmit}
                    validationFailed={() => {
                        console.log('val failed');
                    }}
                    allowShowValidationToastr
                />
                <Col md={8} className="m-auto">
                    <Phone
                        value={phone?.phone}
                        updateMethod={handleOnChange}
                        checkDup
                        require_phone={requirePhone}
                        label="Phone Number"
                    />
                </Col>
                <Col className="text-center">
                    <Button
                        variant="primary"
                        label="Save Changes"
                        type="submit"
                    />
                </Col>
            </form>
        </>
    );
};
